<template>
    <b-modal
        title-tag="h2"
        :title="title"
        :lazy="true"
        :visible="isOpen"
        @close="isOpen = false"
        @hidden="isOpen = false"
    >
        <form>
            <input type="hidden" name="soap_id" :value="soapId" />
            <input type="hidden" name="id" :value="amdId" />
            <b-form-group
                label-cols="3"
                :label-for="`create_date`"
                label="Date:"
            >
                <vet-datetime
                    v-model="createDate"
                    v-validate="'required'"
                    :placeholder="{
                        date: placeholderValue,
                        time: 'Due Time (required)'
                    }"
                    :inner-class="{
                        'border-danger': errors.has('createDate')
                    }"
                    rules="required"
                    container=""
                    name="createDate"
                    :isUpdatePosition="false"
                    @mouseover.native="showDateFormatPlaceholder(true)"
                    @mouseout.native="showDateFormatPlaceholder(false)"
                    :disabled="isSaving"
                    autocomplete="off"
                ></vet-datetime>
            </b-form-group>

            <b-form-group
                label-cols="3"
                :label-for="`Amendment`"
                label="Amendment:"
            >
                <b-form-textarea
                    id="Amendment"
                    v-model="amendment"
                    placeholder="Amendment (required)"
                    :disabled="isSaving"
                ></b-form-textarea>
            </b-form-group>
        </form>

        <template v-slot:modal-footer>
            <loader v-if="isSaving" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="isOpen = false"
                v-if="!isSaving"
            >
                Cancel
            </b-button>

            <b-button
                v-if="!isSaving"
                variant="primary"
                @click="save"
                :disabled="!createDate || !amendment"
            >
                Save
            </b-button>
        </template>
    </b-modal>
</template>

<script>
/**
 * @name AmendmentNewModal
 * @description component confirmation to add new/edit amendment
 */
import PatientSoap from "@/services/patient/patient-soap";
import vetDatetime from "@/module/commons/date-time-picker.vue";
import Loader from "@/module/commons/loader";
import { DateTime } from "luxon";
export default {
    components: {
        vetDatetime,
        Loader
    },
    data() {
        return {
            title: null,
            amdId: null,
            isOpen: false,
            isSaving: false,
            amendment: null,
            createDate: null,
            placeholderValue: "Create Date (required)"
        };
    },
    computed: {
        soapId() {
            return this.soapDetails ? this.soapDetails.id : null;
        },
        soapDetails() {
            return this.$store.getters["soap/soapDetails"];
        }
    },
    methods: {
        open(params) {
            if (params) {
                this.title = "Edit Amendment";

                // prepare date and time
                // Parsing the date and time strings
                let dateObj = DateTime.fromFormat(
                    params.formatted_date,
                    this._dateFormat,
                    { zone: this._timeZone }
                );
                let timeObj = DateTime.fromFormat(
                    params.formatted_time,
                    "hh:mm a",
                    { zone: this._timeZone }
                );

                // Combining the date and time into a single DateTime object
                let combinedDateTime = dateObj.set({
                    hour: timeObj.hour,
                    minute: timeObj.minute,
                    second: timeObj.second
                });

                this.amdId = params.id;
                this.createDate = combinedDateTime;
                this.amendment = params.amendment;
            } else {
                this.title = "New Amendment";
                this.createDate = this._now();
            }
            this.isOpen = true;
        },
        showDateFormatPlaceholder(type, show) {
            if (show) {
                this.placeholderValue = this.datePickerOptions.format;
            } else {
                this.placeholderValue = "Create Date (required)";
            }
        },
        async save() {
            try {
                const params = {
                    soap_id: this.soapId,
                    date: this.createDate.toFormat(this._dateFormat), //same format with business format
                    time: this.createDate.toFormat("hh:mm a"),
                    amendment: this.amendment
                };

                if (this.amdId) {
                    // if edit, append amendment id
                    params.id = this.amdId;
                }

                this.isSaving = true;

                const res = await PatientSoap.saveAmendment(params);
                if (res.code == 200) {
                    this._message(res.message);
                    this.$emit("onSuccess");
                    this.reset();
                } else {
                    this.reset(true);
                    throw "Error: Unable to save";
                }
            } catch (e) {
                this._message("Error: Unable to save", "danger");
                this.isSaving = false;
            }
        },
        reset(closeModal = false) {
            this.createDate = this._now();
            this.amendment = null;
            this.isSaving = false;
            this.isOpen = closeModal;
        }
    }
};
</script>
